const en = {
	header: {
		quote:
			'Books are the ships of thoughts, wandering through the waves of time.',
		author: 'Francis Bacon',
		title1: 'Will help you to',
		p1: 'Create your goal faster and proceed to read',
		p2: 'Divide process proportionally for each day',
		p3: 'Track your success',
		title2: 'You may also',
		p4: 'Pose your own independent point of view',
		p5: 'Improve your professional skills according to new knowledge',
		p6: 'Become an interesting interlocutor',
		logout: 'Logout',
		notifyLogout: 'Hope to see you soon 😘',
		mobBtnLog: 'Log in',
		mobBtnReg: 'Register',
	},
	register: {
		login: 'login',
		register: 'register',
		text: 'Are you with us?',
	},
	libraryForm: {
		book: 'Book title',
		author: 'Author',
		date: 'Publication date',
		pages: 'Amount of pages',
		btnAdd: 'Add',
	},
	mobileLibraryItem: {
		author: 'Author',
		year: 'Year',
		pages: 'Pages',
		rating: 'Rating',
		btn: 'Resume',
	},
	readingListHeaders: {
		title: 'Book Title',
		author: 'Author',
		year: 'Year',
		pages: 'Pages',
		rating: 'Rating',
	},
	listHeaders: {
		title: 'Book Title',
		author: 'Author',
		year: 'Year',
		pages: 'Pages',
	},
	libraryListHeaders: {
		goingToRead: 'Going to read',
		currentlyReading: 'Reading now',
		finishedReading: 'Already read',
	},
	libraryEmpty: {
		step1: 'Step 1.',
		text1: 'Create your own library',
		text2: 'Add there books which you are going to read.',
		step2: 'Step 2.',
		text3: 'Create your first training',
		text4: 'Set a goal, choose period, start training.',
		btn: 'Ok',
	},
	myGoals: {
		title: 'My goals',
		text1: 'Amount of books',
		text2: 'Amount of days',
		text3: 'Books lefts',
	},
	myTraining: {
		title: 'My training',
		option: 'Choose books from the library',
		btn: 'Add',
		warningFields: 'All fields must be filled!',
		warningAdded: 'You already added this book',
		start: 'Start',
		end: 'Finish',
	},
	results: {
		title: 'Results',
		label1: 'Date',
		label2: 'Amount of pages',
		btn: 'Add result',
		stat: 'Statistics',
		notify1part: 'You have entered more pages than are left. Unread pages - ',
		notify2part: ' pages. Enter correct data',
	},
	resumeModal: {
		title: 'Choose book rating',
		resume: 'Resume',
		btnBack: 'Back',
		btnSave: 'Save',
	},
	statistics: {
		startBtn: 'Start training',
		statTitle: 'Amount of pages / day',
		time: 'Time',
		plan: 'PLAN',
		fact: 'FACT',
	},
	notFound: {
		title: 'We are sorry',
		text: 'We seem to have lost this page, try one of these instead.',
		btnBack: 'Reload',
	},
	timer: {
		title1: 'Years countdown',
		title2: 'Goals countdown',
		days: 'Days',
		hours: 'Hours',
		min: 'Mins',
		sec: 'Seconds',
	},
	trainingBookList: {
		title: 'Book Title',
		author: 'Author',
		year: 'Year',
		pages: 'Pages',
	},
	team: {
		footerText: '"Books Reading" by',
		teamButton: 'Go back',
		git: 'GitHub link',
		pavlo: {
			position: 'Team Lead',
			name: 'Pavlo Vovzhynskyy',
		},
		tanya: {
			position: 'Scrum Master',
			name: 'Davydenko Tanya',
		},
		nikita: {
			position: 'Developer',
			name: 'Nikita Krutoholov',
		},
		renat: {
			position: 'Developer',
			name: 'Veliiev  Renat',
		},
		oleh: {
			position: 'Developer',
			name: 'Oleh Poliakov',
		},
		maksym: {
			position: 'Developer',
			name: 'Maksym  Shostak',
		},
		valeriya: {
			position: 'Developer',
			name: 'Valeriya Druchinina',
		},
		anastasiia: {
			position: 'Developer',
			name: 'Anastasiia Svechnikova',
		},
	},
	modalFaster: {
		text: 'Well done! but you need to be a little bit faster. You can do it',
		btnNew: 'New training',
		btnBack: 'Back',
	},
	modalDone: {
		text: 'Congratulations! Another book read.',
		btnDone: 'Done',
	},
};
export default en;
